// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37Jx5","rootMobile":"styles_rootMobile__1kAZ6"};